import { store } from "@store/store";

export const getToken = () => {
  const state = store.getState();
  return state.user.user.token; // 從 Redux 中取得 token
};

export const getBranchId = () => {
  const state = store.getState();
  return state.current.branchId; // 從 Redux 中取得 branchId
};
